export const setSelectedProject = (project) => ({
  type: 'SET_SELECTED_PROJECT',
  payload: project
});